export const defaultPaidMediaPlatforms = [
  { name: 'PMAX', enabled: true },
  { name: 'Search', enabled: true },
  { name: 'Meta', enabled: true },
  { name: 'TikTok', enabled: true },
  // { name: "LinkedIn", enabled: true },
  { name: 'Bing', enabled: true },
  { name: 'Blue', enabled: true },
];
